import env from '@/env';

// The only place that reads VITE_IQ_DOMAIN: every link into IQ Classic is built here so its
// destinations can be changed (e.g. `/go` routing, retiring Classic sections) in one module.
export const CLASSIC_ORIGIN = `https://${env.VITE_IQ_DOMAIN}`;

export const TEAM_BASE_ROUTE = `${CLASSIC_ORIGIN}/team`;
export const PLAYER_BASE_ROUTE = `${CLASSIC_ORIGIN}/player`;
export const MATCH_BASE_ROUTE = `${CLASSIC_ORIGIN}/match`;
export const LEAGUE_BASE_ROUTE = `${CLASSIC_ORIGIN}/competition`;
export const DEFAULT_KEEPER_BASE_ROUTE = `${CLASSIC_ORIGIN}/keeper`;
export const BASE_CLASSIC_EXPLORE_ROUTE = `${CLASSIC_ORIGIN}/scout/search`;

export const classicUrl = (path: string) => `${CLASSIC_ORIGIN}/${path}`;

// A missing or 0 id (navigation ids default to 0 while loading) never yields a Classic URL.
export const classicEntityDashboardUrl = (entity: 'team' | 'player', classicId?: number | string | null) =>
  classicId ? classicUrl(`${entity}/${classicId}/dashboard`) : undefined;

// Competition pages only exist in Classic. Same URL as the side nav's league link.
export const classicCompetitionLeagueTableUrl = (classicId: number) => `${LEAGUE_BASE_ROUTE}/${classicId}/league-table`;
